
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store/order-status",
      function () {
        return require("private-next-pages/[lang]/store/order-status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store/order-status"])
      });
    }
  